<div [formGroup]="detailsForm" class="map-details no-field-space">

  <!-- Loading spinner to prevent user from doing anything during validation. -->
  <div class="loading-spinner" *ngIf="requestRunning">
    <i class="spinner fa-light fa-spinner fa-spin"></i>
  </div>

  <div class="map-upload-button-area">

    <label for="map-upload-button" title="Upload map file">
      <div class="button-content">
        <i class="far fa-map button-icon"></i>
        <div class="button-label">upload Map file</div>
      </div>
    </label>
    <input id="map-upload-button" name="map-btn" class="map-upload-button" type="file" accept="image/*"
      (change)="handleMapChangeEvent($event)" />

  </div>

  <div class="dimensions">
    <mat-form-field class="input">
      <input matInput matInputInteger name="width" formControlName="width"
        placeholder="{{'width' | translate:['tmc-yard.widgets.yard-map-configuration.width', translationService.language]}}"
        [required]="true" type="NUMBER">
    </mat-form-field>

    <div class="spacer"></div>

    <mat-form-field class="input">
      <input matInput matInputInteger name="height" formControlName="height"
        placeholder="{{'height' | translate:['tmc-yard.widgets.yard-map-configuration.height', translationService.language]}}"
        [required]="true" type="NUMBER">
    </mat-form-field>
  </div>

  <div class="legend-orientation">
    <mat-form-field class="input">
      <mat-select
        placeholder="{{'legend position' | translate:['tmc-yard.widgets.yard-map-configuration.legend-position', translationService.language]}}"
        name="legendPosition" formControlName="legendPosition">
        <mat-option [value]="position" *ngFor="let position of legendPositionOptions">
          {{position | translate:['tmc-yard.entity.yard-map-configuration.legend-position.'+position, translationService.language]}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

</div>